<template>
    <div>
        

        <mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="benfEmerFirstName" class="form__label">Nombre(s):</label>
						<input v-model="benfEmerFirstName" type="text" id="benfEmerFirstName" class="form__input" value=""  style="text-transform: capitalize !important;"/>
                          <validation-error :validation="$v.benfEmerFirstName" />
					</div>
				</div>
			</mdb-col>
		</mdb-row>


   

		<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="benfEmerLastName" class="form__label">Apellido Paterno:</label>
						<input v-model="benfEmerLastName"  type="text" id="benfEmerLastName" class="form__input" value=""  style="text-transform: capitalize !important;"/>
                          <validation-error :validation="$v.benfEmerLastName" />
                    </div>
				</div>
			</mdb-col>

			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="benfEmerMotherLastName" class="form__label">Apellido Materno:</label>
						<input type="text" v-model="benfEmerMotherLastName" id="benfEmerMotherLastName" class="form__input" value="" style="text-transform: capitalize !important;" />
                          <validation-error :validation="$v.benfEmerMotherLastName" />
                    </div>
				</div>
			</mdb-col>

		</mdb-row>


        <mdb-row>
            <mdb-col md="4" sm="8" sx="12" style="margin-bottom: 10px;">
                  <div class="form__group">
                    <label for="benfEmerRelationship" class="form__label">Parentesco:</label>
                    <select  v-model="benfEmerRelationship" class="browser-default custom-select">
                        <option selected>Selecciona una opción</option>
                        <option value="Madre">Madre</option>
                        <option value="Padre">Padre</option>
                        <option value="Herman@">Herman@</option>
                        <option value="Hij@">Hij@</option>
                        <option value="Ti@">Ti@</option>
                    </select>
                      <validation-error :validation="$v.benfEmerRelationship" />
                </div>
            </mdb-col>


            <mdb-col lg="4" md="8" sm="12" style="margin-bottom: 10px;">
                <div class="form__group">
                    <label class="form__label" for="benfEmerPhone">Teléfono Celuar:</label>
                    <input type="text" v-model="benfEmerPhone" placeholder="(+52)" v-mask="'##########'" id="benfEmerPhone" class="form__input"/>
                      <validation-error :validation="$v.benfEmerPhone" />
                </div>
            </mdb-col>

        </mdb-row>
 
       
         
    </div>
</template>
<script>
    import { mdbRow, mdbCol } from "mdbvue"; 
    import ValidationError from "../misc/ValidationError";
    import { required, email, minLength, alphaNum, maxLength, sameAs } from "vuelidate/lib/validators";
    import { mask } from "vue-the-mask";

    export default {
        
        name: "BeneficiaryEmergencyContact",
        components: {
            mdbRow,
            mdbCol,
            ValidationError
        },
        directives: {mask},
        data(){
            return{
                benfEmerFirstName:"",
                benfEmerLastName:"",
                benfEmerMotherLastName:"",
                benfEmerRelationship:"",
                benfEmerPhone:"",
                emergencyPhone : []
            }
        },
        validations: {
            benfEmerFirstName: {
                required
            },
            benfEmerLastName: {
                required
            },
            benfEmerMotherLastName: {
                required
            }, 
            benfEmerRelationship:{
                required
            },
            benfEmerPhone: {
                required
            }


        },
        created(){
            this.userAllData = JSON.parse(localStorage.getItem("userAllData"));
            this.personalMail = this.userAllData.personalMail;

            if(this.userAllData.phones.length > 0){
				
                let phones = this.userAllData.phones;
				
                // 1.- DETECTAMOS EL TIPO DE TELEFONO
					for (let i = 0; i < phones.length; i++){
						//console.log("phoneType --> ", phones[i].phoneType );
						
                        // 1.- Para el celular de usuario 
                        if(phones[i].phoneType == "Emergency"){

                                let fullName = phones[i].contactName.replace(/  +/g, ' ').split(' ');
                                //console.log("fullName", fullName);

                                if(fullName[0]){
                                    this.benfEmerFirstName = fullName[0];
                                }

                                if(fullName[1]){
                                    this.benfEmerLastName = fullName[1];
                                }

                                if(fullName[2]){
                                    this.benfEmerMotherLastName = fullName[2];
                                }
                                
                                 
                                

                                this.benfEmerRelationship = phones[i].contactRelationship;
                                this.benfEmerPhone = phones[i].phoneNumber;

						}
 
                      
                      

					}
			}
        },
        methods: {
            
            getFormdata(){

                this.$v.$touch();
                
    
               
                if (this.$v.$invalid){
                    return false;
                }
                else {
                    let phoneList = { 
                    phone:this.benfEmerPhone,
                    contactName: this.benfEmerFirstName + " " + this.benfEmerLastName + " " + this.benfEmerMotherLastName,
                    contactRelationship:this.benfEmerRelationship,
                    phoneType:"Emergency"
                }  
                    
                    return phoneList;
                }

            }
        }


    
    }
</script>